/* eslint-disable @next/next/no-img-element */
import useCommon from '@utils/hooks/common';
import styles from './styles';
import CustomSelect from '@components/CustomSelect';
import {SelectProps} from 'antd';
import useRequest from '@utils/hooks/useRequestCustom';
import authApi from '@utils/api/auth.api';
import {Skeleton} from 'antd-mobile';
import countryListJson from '@utils/country-list.json';
import {LANG_CODE} from '@constant/system';

export const DEFAULT_COUNTRY_CODE = 'HKG';

interface CountrySelectorProps extends SelectProps {}

const languageNameMap = new Map([
  [LANG_CODE.EN_US, 'engName'],
  [LANG_CODE.ZH_HK, 'chineseName'],
  [LANG_CODE.AR, 'arabicName'],
  [LANG_CODE.ES, 'spanishName'],
  [LANG_CODE.HI, 'hindiName'],
  [LANG_CODE.JA, 'japaneseName'],
  [LANG_CODE.KO, 'koreanName'],
  [LANG_CODE.MN, 'mongolianName'],
]);

const CountrySelector = (props: CountrySelectorProps) => {
  const {...rest} = props;

  const {data: countryList, loading} = useRequest(authApi.getCountryList);

  const {classes, t, user, system, language} = useCommon({
    withTranslation: ['country'],
    withStyles: styles,
    observers: ['user', 'system', 'language'],
  });

  const {currentLanguage} = language || {};

  const getCountryName = (countryCode: string) => {
    const obj = countryListJson.find(country => country.countryCode === countryCode);
    const key = languageNameMap.get(currentLanguage);
    if (obj?.[key]) {
      return obj[key];
    }
    if (obj.engName) {
      return obj.engName;
    }
    return countryCode;
  };

  const countryOptions = countryList?.data?.countries.map(country => ({
    label: (
      <div className={classes.option}>
        <img
          src={`/images-mobile/country/${country?.countryCode}.webp`}
          alt={country}
          className={classes.countryIcon}
          onError={e => {
            e.currentTarget.src = '/images-mobile/country/dummy_country_flag.webp';
          }}
        />
        {/* <span className={classes.countryLabel}>{t(country?.engName)}</span> */}
        <span className={classes.countryLabel}>{getCountryName(country?.countryCode)}</span>
      </div>
    ),
    value: country?.countryCode,
  }));

  return loading ? (
    <Skeleton style={{height: 50, width: '100%', borderRadius: 10}} />
  ) : (
    <CustomSelect
      options={countryOptions}
      className={classes.countrySelector}
      {...rest}
      // defaultValue={DEFAULT_COUNTRY_CODE}
    />
  );
};

export default CountrySelector;
